export enum Images {
  FRACTAL_LOGO = '/assets/images/iqigaiAiLogo.svg',
  SIGNIN_BANNER = '/assets/images/banner1.svg',
  SIGNIN_BANNER_BLUE = '/assets/images/banner1_blue.svg',
  BANNER_CLOUD = '/assets/images/banner-cloud.svg',
  CALENDAR_ICON = '/assets/images/calendar-icon.svg',
  RIGHT_ARROW = '/assets/images/right-arrow.svg',
  RESUME_DROP = '/assets/images/resume-drop.svg',
  RESUME_UPLOAD_NEW = '/assets/images/upload_resume_new.svg',
  RESULT_ICON = '/assets/images/result-icon.svg',
  NOTIFICATION_ICON = '/assets/images/notification-icon.svg',
  LANDING_PAGE = '/assets/images/landing-page.svg',
  INSTALL_PLUGIN = '/assets/images/install-plugin.svg',
  INFO_ICON = '/assets/images/info-icon.svg',
  GREEN_CHECK = '/assets/images/green-check.svg',
  DELETE_ICON = '/assets/images/delete.svg',
  ASSESSMENT_ICON = '/assets/images/assessment-icon.svg',
  ADD_CIRCLE = '/assets/images/add-circle.svg',
  ADD_CIRCLE_ACTIVE = '/assets/images/add-circle-active.svg',
  INFO_CIRCLE = '/assets/images/info-circle.svg',
  CONTINUE_ICON = '/assets/images/continue.svg',
  CONTINUE_ICON_BLUE = '/assets/images/continue_blue.svg',
  VERTICAL_LINE = '/assets/images/verticalLine.svg',
  VERTICAL_LINE_RIGHT = '/assets/images/verticalLineRight.svg',
  RIGHT_ARROW_ONE = '/assets/images/rightArrow.svg',
  RIGHT_ARROW_EXAMINATION_TOPBAR = '/assets/images/right_arrow_examination_topbar.svg',
  RIGHT_ARROW_ONE_BLUE = '/assets/images/rightArrow_blue.svg',
  PREVIEW_RESUME_IMAGE = '/assets/images/previewResume.svg',
  COMPLETE_RESUME_IMAGE = '/assets/images/completeResume.svg',
  DOWN_ARROW = '/assets/images/downArrow.svg',
  UP_ARROW = '/assets/images/upArrow.svg',
  CLOCK_ICON = '/assets/images/clock.svg',
  CROSS_CIRCLE = '/assets/images/cross-circle.svg',
  DELETE_TRASH_ICON = '/assets/images/trash.svg',
  RESUME_DROP_COLOR = '/assets/images/resume_drop_color.svg',
  DISABLED_AUDIO_OR_VIDEO = '/assets/images/disabled_video_Or_audio.svg',
  LOCK_ICON = '/assets/images/lock.svg',
  USER_IMAGE_ICON = '/assets/images/userImage.svg',
  DROPDOWN_ICON = '/assets/images/dropdown.svg',
  CORRECT_TICK_ICON = '/assets/images/correct.svg',
  DOWNLOAD_ICON = '/assets/images/download-icon.svg',
  CORRECT_TICK_ICON_NEW = '/assets/images/check-circle.svg',
  CORRECT_TICK_ICON_GREY = '/assets/images/check-circle-gray.svg',
  CORRECT_TICK_ICON_GREEN = '/assets/images/check-circle-green.svg',
  HORIZONTAL_LINE = '/assets/images/hroizontal-line.svg',
  COUNTRY_DROPDOWN = '/assets/images/country-dropdown.svg',
  AUDIO_PERMISSION = '/assets/images/audio-permission.png',
  CAMERA_PERMISSION = '/assets/images/camera-permission.png',
  ALLOW_WARNING = '/assets/images/allow-warning.svg',
  AUDIO_VIDEO_SETUP = '/assets/images/audio-video-setup-1.png',
  GROUND_RULES = '/assets/images/ground-rules.png',
  READY_ASSESSMENT = '/assets/images/ready-assessment.svg',
  ASSESSMENT_ECLIPS = '/assets/images/assessment-eclips.jpg',
  CHECKMARK_ICON = '/assets/images/checkMark.svg',
  ENABLE_VIDEO_AND_AUDIO = '/assets/images/enable_Video_Audio.png',
  SCREEN_SHARE = '/assets/images/screen-share.png',
  STEPPER_CHECKMARK = '/assets/images/stepperCheckMark.svg',
  DASHBOARD_ASSESSMENT_ICON = '/assets/images/assessment-icon-bg.svg',
  PLAY_ICON = '/assets/images/play.svg',
  PLAY_ICON_BLUE = '/assets/images/play_blue.svg',
  ASSESSMENT_CHECK = '/assets/images/assessment-check.svg',
  ASSESSMENT_CLOCK = '/assets/images/assessment-clock.svg',
  SEARCH_ICON = '/assets/images/search.svg',
  CLOUD_ADD = '/assets/images/cloud-add.svg',
  ALLOW_ICON = '/assets/images/alert.svg',
  DELETE_ICON_IN_POPUP = '/assets/images/deleteIcon.png',
  PROFILE_COVER_IMAGE = '/assets/images/profile-cover.jpg',
  EDIT_IMAGE = '/assets/images/edit-2.svg',
  EDIT_IMAGE_BLUE = '/assets/images/edit-2_blue.svg',
  AT_SIGN = '/assets/images/at-sign.svg',
  LOCATION_SIGN = '/assets/images/location-tick.svg',
  LINKEDIN_IMG = '/assets/images/linkedIn_Btn.svg',
  GITHUB_IMG = '/assets/images/gitHub_btn.svg',
  PROFILE_EDUCATION = '/assets/images/profile-education.svg',
  PROFILE_INTERNSHIP = '/assets/images/profile-internship.png',
  AVATAR = '/assets/images/Avatar.svg',
  CAMERA = '/assets/images/Camera.svg',
  ZOOM_IN = '/assets/images/Zoom-in.svg',
  ZOOM_OUT = '/assets/images/Zoom-out.svg',
  USER_PROFILE = '/assets/images/profile-circle.svg',
  DOCUMENT = '/assets/images/document-text.svg',
  ADD_ICON = '/assets/images/add-icon.svg',
  ADD_ICON_BLUE = '/assets/images/add-icon_blue.svg',
  OPEN_EYE = '/assets/images/eye.svg',
  CLOSE_EYE = '/assets/images/eye-slash.svg',
  EDIT_ICON = '/assets/images/receipt-edit.svg',
  ASSESSMENT_DETAILS_ICON = '/assets/images/assessmentListIcon.svg',
  ARROW_RIGHT = '/assets/images/arrowRight.svg',
  ASSESSMENT_LIST_ICON_ONE = '/assets/images/assessmentListImage.svg',
  ASSESSMENT_LIST_ICON_TWO = '/assets/images/assessmentListImage2.svg',
  USER_ADDED = '/assets/images/User Added.svg',
  VIEW_DETAILS_ASSESSMENT_ICON = '/assets/images/viewdetails-assessment-icon.svg',
  ASSESSMENT_TICK_WHITE_ICON = '/assets/images/tickWhite.svg',
  WHITECHECK_TICK = '/assets/images/white-check.svg',
  VIDEO_START = '/assets/images/start-camera-button.svg',
  mobileScreenBg = '/assets/images/mobile-steppers-bg.svg',
  QR_CODE = '/assets/images/QR_Code.svg',
  VERIFY_SURROUNDING = '/assets/images/verify-surrounding(1).png',
  WEBSITE_ICON = '/assets/images/website-icon.svg',
  SUB_CATEGORY_MENU = '/assets/images/sub-category-menu.svg',
  PLUS_ICON = '/assets/images/plus.svg',
  SETTINGS_ICON = '/assets/images/setting-icon.svg',
  CORRECT_IMAGE = '/assets/images/corrcetImage.svg',
  DOTTED_LINE = '/assets/images/dots-vertical.svg',
  SIGN_OUT_ICON = '/assets/images/sign-out-img.svg',
  CHANGE_PASSWORD_ICON = '/assets/images/change-password-img.svg',
  PROCESSED_ICON = '/assets/images/Dual Ring-5s-200px.svg',
  REGISTER_ICON = '/assets/images/register.svg',
  REGISTER_ICON_BLUE = '/assets/images/register_blue.svg',
  COPY_ICON = '/assets/images/fractal-copy-icon.svg',
  HR_FILTER_ICON = '/assets/images/fractal-filter-icon.svg',
  HR_SEARCH_ICON = '/assets/images/fractal-search-icon.svg',
  HR_SORT_ICON = '/assets/images/fractal-sort-icon.svg',
  DRIVE_SCHEDULED = '/assets/images/drive-scheduled.svg',
  RED_DOT_ICON = '/assets/images/fractal-red-dot.svg',
  RIGHT_ICON = '/assets/images/fractal-right-icon.svg',
  GRAY_DOT_ICON = '/assets/images/fractal-gray-dot.svg',
  TIME_DATE_PICKER_ACTIVE = 'assets/images/time-date-picker-active.svg',
  TIME_DATE_PICKER_INACTIVE = '/assets/images/time-date-picker-inactive.svg',
  CANDIDATE_J_ICON = '/assets/images/candiadate-j-icon.svg',
  CANDIDATE_GROUP_ICON = '/assets/images/candidate-group-ican.svg',
  COPY_BLUE_ICON = '/assets/images/copy-blue-icon.svg',
  SELECT_DROP_DOWN_ICON = '/assets/images/select-drop-down.svg',
  TIMER_ICON = '/assets/images/timer.svg',
  ATTEMPT_LATER_ICON = '/assets/images/attempt-later.svg',
  MENU_ICON = '/assets/images/menuIcon.svg',
  PREVIEW_QUESTION = '/assets/images/preview-question.svg',
  NEXT_QUESTION = '/assets/images/next-question.svg',
  ATTEMPT_LATER_SHOW = '/assets/images/attempt-later-show-icon.svg',
  CLOSE_ICON = '/assets/images/close_icon.svg',
  PROFILE_DETAILS_MOBILE = '/assets/images/profile-details-mobile-icon.svg',
  RECTANGLE_ICON = '/assets/images/rectangle-icon.svg',
  START_RECORD_VIDEO = '/assets/images/record-video.svg',
  STOP_RECORD_VIDEO = '/assets/images/stop-video-recording.svg',
  RED_TIMER_ICON = '/assets/images/red_timer.svg',
  VIDEO_STOP = '/assets/images/stop.png',
  VIDEO_ONGOING = '/assets/images/icons8-circle-around-windows-11-filled-96.png',
  PLAY = '/assets/images/play.svg',
  PAUSE = '/assets/images/pause.svg',
  QUESTION_BANK = '/assets/images/book.svg',
  QUESTION_REPORT = '/assets/images/report.svg',
  UPLOAD = '/assets/images/upload.svg',
  CHATGPT = '/assets/images/chatgpt.svg',
  CHATGPT_ICON = '/assets/images/chatgpt-icon.svg',
  ARROW_UP = '/assets/images/arrow-narrow-up.svg',
  MOBILE_ERROR = '/assets/images/mobile-connection.svg',
  DRAG_DROP_ICON = '/assets/images/drag&dropIcon.svg',
  MINUS_CIRCLE = '/assets/images/minus-cirlce.svg',
  PRE_SEARCH = '/assets/images/pre-search.svg',
  CLOSE_SEARCH = '/assets/images/close-circle.svg',
  CLOSE_SEARCH_HOVER = '/assets/images/close-circle-hover.svg',
  REVIEW_IMAGE = '/assets/images/review.svg',
  CLOSE_REPORT_GENERATION_ICON = '/assets/images/x.svg',
  DOWNLOAD_REPORT = '/assets/images/download-report.svg',
  RESUME_ERROR = '/assets/images/resume-error.gif',
  REJECT_ICON = '/assets/images/reject.svg',
  APPROVE_ICON = '/assets/images/DoneIcon.svg',
  BOT_IMAGE = '/assets/images/bot-image.png',
  SELECT_CODING_LANGUAGE = '/assets/images/code.svg',
  DUAl_RING_GIF = '/assets/images/Dual Ring-5s-200px.gif',
  EXECUTE_CODE_ICON = '/assets/images/icons8-play.png',
  EXPAND_GIF = '/assets/gifs/double-up.gif',
  MAXIMIZE_ARROW = '/assets/images/maximize-arrow.svg',
  RECORDED_ICON = '/assets/images/done-gray.svg',
  PLAY_AUDIO_ICON = '/assets/images/play-audio.svg',
  PAUSE_AUDIO_ICON = '/assets/images/pause-audio.svg',
  RECORDED_AUDIO_ICON = '/assets/images/audio-question.svg',
  RECORD_AUDIO_ICON = '/assets/images/record-btn.svg',
  RECORD_AGAIN_ICON = '/assets/images/record-again-btn.svg',
  USER_PROFILE_ICON = '/assets/images/profile-2user.svg',
  CROWN_ICON = '/assets/images/crown.svg',
  CANDIDATE_ICON = '/assets/images/candidate.svg',
  CANDIDATE_DETAILS_ICON = '/assets/images/drive-user.svg',
  BLACKLIST_CANDIDATE_ICON = '/assets/images/blacklist.svg',
  DOWNLOAD_EXCEL = '/assets/images/receive-square.svg',
  EMPTY_LIST_ICON = '/assets/images/Empty-List.svg',
  DRIVE_ICON = '/assets/images/drive.svg',
  DOWNLOAD_DRIVE = '/assets/images/download-drive.svg',
  CLONE_ICON = '/assets/images/clone.svg',
  EXTEND_DRIVE_ICON = '/assets/images/extend-drive.svg',
  ACTIVE_CANDIDATE_ICON = '/assets/images/active-candidate.svg',
  INACTIVE_CANDIDATE_ICON = '/assets/images/inactive-candidate.svg',
  IMAGE_CAPTURE_LAYOUT = '/assets/images/capture-layout.svg',
  CAPTURE_PICTURE = '/assets/images/capture.svg',
  CAPTURE_PICTURE_BLUE = '/assets/images/capture_blue.svg',
  GROUP_TAB = '/assets/images/groupTab.svg',
  QUESTION_STORE = '/assets/images/store-icon.svg',
  DELETE_CONFIRMATION = '/assets/images/Delete_Confirmation.svg',
  MIND_BLOWING = '/assets/images/Mind Blowing.svg',
  BACKGROUND_APPS = '/assets/images/background-apps.svg',
  MULTIPLE_DISPLAY = '/assets/images/Searching-Looking.svg',
  EXTERNAL_DEVICE = '/assets/images/Security.svg',
  SHARED_ICON = '/assets/images/External-link.svg',
  IDE_ICON = '/assets/images/IDE.svg',
  BLUE_LEFT_ARROW = '/assets/images/blue-left-arrow.png',
  FULL_SCREEN_ICON = '/assets/images/fullscreen.png',
  MAXIMIZE_ICON = '/assets/images/maximize.png',
  MINIMIZE_ICON = '/assets/images/minimize.png',
  MAXIMIZE_ICON_YELLOW = '/assets/images/maximize2.svg',
  MINIMIZE_ICON_YELLOW = '/assets/images/minimize2.svg',
  MAXIMIZE_ICON_BLUE = '/assets/images/maximize_blue.svg',
  MINIMIZE_ICON_BLUE = '/assets/images/minimize_blue.svg',
  REFRESH_ICON = '/assets/images/refresh.svg',
  ALLOW_AUDIO_VIDEO_PERMISSION_APP = '/assets/images/allow-audio-video-app.png',
  INFO = '/assets/images/info.png',
  DOWNLOAD_ICON1 = '/assets/images/Download_icon1.svg',
  BLUE_DOWNLOAD_ICON = '/assets/images/blue_download.svg',
  NOT_CULTURAL_FIT = '/assets/images/Not_cultural_fit.svg',
  SHORTLISTED_IMAGE = '/assets/images/shortlisted_image.svg',
  PASSED_PROCTORING = '/assets/images/passed_proctoring.svg',
  USER_PROFILE_ICON_CIRCLE = '/assets/images/user_profile_icon.svg',
  NOT_PASSED_PROCTORING = '/assets/images/not-passed-proctoring.svg',
  SOUND_ICON_CIRCLE = '/assets/images/sound_image.svg',
  PREV_BTN = '/assets/images/prev-btn.svg',
  NEXT_BTN = '/assets/images/next-btn.svg',
  PROCTORING_SUSPICIOUS = '/assets/images/proctoring-suspicious.svg',
  SERVER_HEALTH = '/assets/images/server-health.svg',
  HIDE_TRANSCRIPT = '/assets/images/hideTranscriptIconv2.svg',
  TRANSCRIPT = '/assets/images/transcriptIconv2.svg',
  USER_VIDEO_MEDIA_ICON = '/assets/images/videoMediaIcon.svg',
  USER_VIDEO_MEDIA_OFF_ICON = '/assets/images/userVideoOffIconv2.svg',
  MINIMIZE_LAYOUT_ICON = '/assets/images/MinimizeLayoutIcon.svg',
  MAXIMIZE_LAYOUT_ICON = '/assets/images/layoutMaximizeIcon.svg',
  MICROPHONE_ICON = '/assets/images/microphoneIcon.svg',
  MICROPHONE_OFF_ICON = '/assets/images/micOffIconv2.svg',
  IQIGAI_LOGO = '/assets/images/iqigaiV2Logo.svg',
  MALE_VOICE_ASSISTANT = '/assets/images/Guy.png',
  FEMALE_VOICE_ASSISTANT = '/assets/images/Girl.png',
  IQIGAI_AI_LOGO = '/assets/images/iqigaiAiLogo.svg',
  DESKTOP_APP_ICON = '/assets/images/app-icon.png',
  LIGHT_BLUE_DROPDOWN_ICON = '/assets/images/lightBlueDropdown.svg',
  LIGHT_BLUE_INFO_ICON = '/assets/images/lightBlueInfo.svg',
  INTERVIEW_STATUS = '/assets/images/Interview-status.svg',
  PLAY_BTN = '/assets/images/playBtn.svg',
  PASSED_TESTCASE_ICON = '/assets/images/cross_icon_image.svg',
  FAILED_TESTCASE_ICON = '/assets/images/tick_icon_image.svg',
  GRAY_INFO_ICON = '/assets/images/code_quality_info.svg',
  BLUE_CORRECT_ICON = '/assets/images/blue_correct_icon.svg',
  SUBMIT_DRIVE = '/assets/images/submit-drive.svg',

  RESUME_UPLOAD = '/assets/images/resume-upload.svg',
  BOT_ERROR = '/assets/images/bot-error.svg',
  BOT_REFRESH = '/assets/images/bot-refresh.svg',

  OFFLINE_IMAGE_1 = '/assets/images/offline-image-1.png',
  OFFLINE_IMAGE_2 = '/assets/images/offline-image-2.png',
  OFFLINE_IMAGE_3 = '/assets/images/offline-image-3.png',
  OFFLINE_IMAGE_4 = '/assets/images/offline-image-4.png',
  OFFLINE_IMAGE_5 = '/assets/images/offline-image-5.png',
  SKIP_BUTTON = '/assets/images/skip-btn.png',
  SUBMIT_PROGRESS = '/assets/images/submit-progress.svg',
  FEEDBACK_BOT = '/assets/images/feedback-bot.svg',
  IDE_WAITING_SCREEN_01 = '/assets/images/IDE-waiting-screen-01.svg',
  IDE_WAITING_SCREEN_02 = '/assets/images/IDE-waiting-screen-02.svg',
  IDE_WAITING_SCREEN_03 = '/assets/images/IDE-waiting-screen-03.svg',
  CODE_OVERLAY_CLOSE_ICON = '/assets/images/code_overlay_cross.svg',
  DARK_GREEN_APPROVE_ICON = '/assets/images/darkGreenApproveIcon.svg',
  TILTED_ARROW_ICON = '/assets/images/tiltedArrowIcon.svg',
  VIDEO_ICONS = '/assets/images/video-icon.svg',
  UPLOAD_RESUME_IMAGE_FAILED = '/assets/images/upload_resume_image.svg',
  UPLOAD_RESUME_IMAGE_SUCCESS = '/assets/images/UploadResumeSuccess.svg',
  EXCLAMATION_GRAY = '/assets/images/exclamation-grey.svg',
  EXCLAMATION_MARK = '/assets/images/exclamation.svg',
  EXPAND_CODING = '/assets/images/expand-coding.svg',
  UP_AND_DOWN_ARROW = '/assets/images/up-down-svgrepo-com.svg',
  ARROW = '/assets/images/up-arrow.svg',
  RED_CROSS = '/assets/images/red-cross.svg',
  GREEN_TICK = '/assets/images/green-tick.svg',
  BOLD_CROSS = '/assets/images/bold-cross.svg',
  EDIT_QUESTION = '/assets/images/edit-question.svg',
  DELETE_QUESTION = '/assets/images/delete-question.svg',
  STAFFING_MENU = '/assets/images/staffing-menu.svg',
  NAVIGATION_ARROW = '/assets/images/navigation-arrow.svg',
  DRIVES_DEFAULT = '/assets/images/drives-default.svg',
  HOME_DEFAULT = '/assets/images/home-default.svg',
  PROFILE_DEFAULT = '/assets/images/profile-default.svg',
  DOCUMENT_UPLOAD_DEFAULT = '/assets/images/document-upload-default.svg',
  HOME_ACTIVE = '/assets/images/home-active.svg',
  DRIVES_ACTIVE = '/assets/images/drives-active.svg',
  PROFILE_ACTIVE = '/assets/images/profile-active.svg',
  DOCUMENT_UPLOAD_ACTIVE = '/assets/images/document-upload-active.svg',
  ADD_CUSTOM_FILTER = '/assets/images/add-custom.svg',
  ADD_CUSTOM_FILTER_HOVER_ICON = '/assets/images/add-custom-hover.svg',
  DISABLED_CUSTOM_FILTER='/assets/images/disabled-custom-filter.svg',
  SORT_ICON = '/assets/images/sort.svg',
  WHITE_EDIT_ICON = '/assets/images/white-edit-icon.svg',
  DOCUMENT_DOWNLOAD_ICON = '/assets/images/document-download.svg',
  RECOMMEND_ICON = '/assets/images/recommend.svg',
  FUNNEL_SORT_ICON = '/assets/images/funnel-sort.svg',
  BLUE_TICK_ICON = '/assets/images/Blue-tick.svg',
  LOCK_PRIMARY_COLOR_ICON = '/assets/images/lock-primary-color.svg',
  REVIEW_PRIMARY_COLOR_ICON = '/assets/images/review-icon-primary.svg',
  DELETE_RED_ICON = '/assets/images/delete-red-bg.svg',
  USER_PERSON_ICON = '/assets/images/user-person_primary.svg',
  BACK_BUTTON_ICON = '/assets/images/back_button.svg',
  DOUBLE_PLUS_ICON = '/assets/images/double_plus.svg',
  MULTIPLE_PLUS_BUTTONS_BEHIND = '/assets/images/multiple_plus_buttons.svg',
  THREE_DOTS_ROUNDED = '/assets/images/three_dots_button_rouded.svg',
  DELETE_ICON_THREE = '/assets/images/delete-icon-3.svg',
  EDIT_ICON_THREE = '/assets/images/edit_icon-3.svg',
  NEW_INFO_ICON = '/assets/images/new_info_icon.svg',
  ALERT_PRIMARY_COLOR_IMAGE = '/assets/images/alert_Image_primary_color.svg',
  YELLOW_CROSS_ICON = '/assets/images/yellow-cross-circle.svg',
  QUESTION_MARK_UNDER_CIRCLE = '/assets/images/question_mark_under_circle.svg',
  HASH_ICON = '/assets/images/hash_icon.svg',
  CLOCK_ICON1 = '/assets/images/clock_icon1.svg',
  ORGANAISATION_ICON1 = '/assets/images/organisation_icon1.svg',
  USER_CHECKED_ICON = '/assets/images/user_checked.svg',
  OPEN_EYE1 = '/assets/images/eye-show 2.svg',
  SORT_ICON1 = '/assets/images/sort_icon1.svg',
  FILTER_ICON1 = '/assets/images/filter_icon1.svg',
  SEARCH_ICON1 = '/assets/images/search_icon1.svg',
  RESET_ICON2 = '/assets/images/reset_icon1.svg',
  NOTIFICATION_ICON2 = '/assets/images/notification_icon2.svg',
  QUESTION_MARK_WITH_RED_ICON = '/assets/images/questionMarkwith_red_icon.svg',
  SERVER_ICON = '/assets/images/server_icon.svg',
  ADMIN_HR_PROFILE_IMAGE = '/assets/images/admin_user_profile.svg',
  

  // carousals
  CAROUSEL1 = '/assets/images/carousal_1.svg',
  CAROUSEL2 = '/assets/images/carousal_2.svg',
  CAROUSEL3 = '/assets/images/carousal_3.svg',
  ADMIN_CAROUSEL1_BLUE_THEME = '/assets/images/carousal_blue_theme1.svg',
  ADMIN_CAROUSEL2_BLUE_THEME = '/assets/images/carousal_blue_theme2.svg',
  ADMIN_CAROUSEL3_BLUE_THEME = '/assets/images/carousal_blue_theme3.svg',
  ADMIN_CAROUSEL4_BLUE_THEME = '/assets/images/carousal_blue_theme4.svg',

  // Proctoring settings
  PROCTORING_SCREEN_CAMERA = '/assets/images/aadharPhotoCapture.svg',
  BACK_ARROW_NAVIGATION = '/assets/images/back_arrow_navigation.svg',
  GENERATE_REPORT = '/assets/images/generate_report.svg',
  DOWNLOAD_REPORT_UPDATED = '/assets/images/download_report.svg',
  LOGO_NEW_HEADER = '/assets/images/logo_new_header.svg',
  ADD_NEW_USER_ICON = '/assets/images/Add_new_user_icon.svg',
  ADD_NEW_USER_ICON_BLUE = '/assets/images/ADD_NEW_USER_ICON_BLUE.svg',
  ADD_NEW_USER_CROSS = '/assets/images/Add_new_user_cross.svg',
  EDIT_USER_ADMIN = '/assets/images/Edit_user.svg',
  VIEW_GROUPS_ADMIN = '/assets/images/View_groups_admin.svg',
  VIEW_GROUPS_ADMIN_BLUE_ICON = '/assets/images/View_groups_blue_icon_admin.svg',
  CREATE_GROUP_ADMIN = '/assets/images/create_group_admin.svg',
  CREATE_GROUP_ADMIN_BLUE_ICON = '/assets/images/Create_croup_admin_blue_icon.svg',
  CREATE_ASSESSMENT_BLUE = '/assets/images/create_assessment_blue.svg',
  CREATE_ASSESSMENT = '/assets/images/create_assessment.svg',
  ADD_NEW_GROUP = '/assets/images/Add_new_grp_admin.svg',
  ADD_NEW_QUESTION = '/assets/images/add_new_question.svg',
  ADD_NEW_QUESTION_BLUE = '/assets/images/add_new_question_blue.svg',
  MCQ_ADD_NEW_QUESTION = '/assets/images/MCQ_add_new_question.svg',
  GROUP_NAME_DROPDOWN = '/assets/images/Group_name_dropdown.svg',
  FIB_ADD_NEW_QUESTION = '/assets/images/Fib_add_new_question.svg',
  MCQ_OPTION_PREV_ICON = '/assets/images/mcq_option_icon.svg',
  MINUS_CIRCLE_ADMIN = '/assets/images/minus_circle_admin.svg',
  PREVIEW_POPUP_ICON = '/assets/images/Preview_popup_icon.svg',
  PREVIEW_QUESTION_ICON = '/assets/images/preview_question_icon.svg',
  SELECT_ANY_ONE_ICON = '/assets/images/select_any_one_icon.svg',
  NEW_SEARCH_ADMIN = '/assets/images/new_search_admin.svg',
  ADD_NEW_GRP = '/assets/images/add_new_grp.svg',
  LINK_QUESTION = '/assets/images/link_question.svg',
  LINK_QUESTION_THREE_DOTS = '/assets/images/link_question_three_dots.svg',
  ADD_GROUP_POPUP_ICON = '/assets/images/add_group_popup_icon.svg',
  VIEW_QUESTION_POPUP_ICON = '/assets/images/View_question_PopUp_icon.svg',
  REMOVE_LINK_QUESTION = '/assets/images/remove_link_question.svg',
  DEFAULT_SCREEN = '/assets/images/default_screen.svg',
  QUESTION_CATALOG = '/assets/images/question_catelog.svg',
  FILTER_ADMIN_LINK_QUESTION = '/assets/images/filter_admin_link.svg',
  LINK_QUESTION_MAIN_ICON = '/assets/images/linkQuestion_blue_main_icon.svg',
  LINK_QUESTION_LITE_ICON = '/assets/images/link_question_lite_icon.svg',
  EDIT_GROUP_ADMIN = '/assets/images/edit_group_admin.svg',

  CLONE_ASSESSMENT = '/assets/images/clone 1.svg',
  REVIEW_ASSESSMENT = '/assets/images/Review_assessment.svg',
  PUBLISH_ASSESSMENT = '/assets/images/publish_assessment.svg',
  ADD_SECTIONS = '/assets/images/add_sections.svg',
  PUBLISH_ASSESSMENT_BLUE = '/assets/images/publish_assessment_blue_theme.svg',
  ADD_SECTIONS_BLUE = '/assets/images/add_sction_blue.svg',
  SCORE_EVALUATION_SECTION = '/assets/images/score_evaluation_section.svg',
  CHATGPT_SECTION = '/assets/images/chatgpt_section.svg',
  TECH_INTERVIEW_SECTION = '/assets/images/tech_interview.svg',
  CULTURAL_FIT_INTERVIEW = '/assets/images/cultural_fit.svg',
  QUESTION_RESON_EXPLAIN = '/assets/images/question_reason_explain.svg',
  SHUFFLE_SECTION = '/assets/images/shuffle_section.svg',
  TOTAL_QUESTION = '/assets/images/total_question_sub_section.svg',
  ADD_EDIT_SUB_SECTION = '/assets/images/add_edit_sub_section.svg',
  CREATE_CATALOG = '/assets/images/create_catalog.svg',
  EXPORT_QUESTION_COUNT = '/assets/images/export_question_count.svg',
  SELECT_QUESTION_TYPE = '/assets/images/select_question_type.svg',
  RESET_QUESTION_SELECTION = '/assets/images/reset_question.svg',
  APPLY_FILTER_CATALOG = '/assets/images/apply_filter_question_catalog.svg',
  LIGHT_BLUE_FILTER_DD = '/assets/images/LIGHT_BLUE_FILTER_DD.svg',
  ADD_CONDITION_BLUE = '/assets/images/ADD_CONDITION_BLUE.svg',
  APPLY_FILTER_CATALOG_BLUE = '/assets/images/APPLY_FILTER_CATALOG_BLUE.svg',
  SELECT_SUBCATEGORY = '/assets/images/SELECT_SUBCATEGORY.svg',
  TOTAL_QUESTIONS = '/assets/images/TOTAL_QUESTIONS.svg',
  EASY_QUESTIONS = '/assets/images/EASY_QUESTIONS.svg',
  MEDIUM_QUESTIONS = '/assets/images/MEDIUM_QUESTIONS.svg',
  HARD_QUESTION = '/assets/images/HARD_QUESTION.svg',
  USER_PROFILE_SELECTED = '/assets/images/USER_PROFILE_SELECTED.svg',
  ASSESSMENT_TAB_SELECTED = '/assets/images/ASSESSMENT_TAB_SELECTED.svg',
  QUESTION_BANK_SELECTED = '/assets/images/QUESTION_BANK_SELECTED.svg',
  GROUPS_TAB_SELECTED = '/assets/images/GROUPS_TAB_SELECTED.svg',
  QUESTION_CATALOG_SELECTED = '/assets/images/QUESTION_CATALOG_SELECTED.svg',
  RESET_PASSWORD = '/assets/images/RESET_PASSWORD.svg',
  REPORTED_BY_USER = '/assets/images/REPORTED_BY_USER.svg',
  ASSESSMENT_GROUP = '/assets/images/ASSESSMENT_GROUP.svg',
  REPORTED_ON_DATE = '/assets/images/REPORTED_ON_DATE.svg',
  REASON_PROVIDED = '/assets/images/REASON_PROVIDED.svg',
  FEEDBACK = '/assets/images/FEEDBACK.svg',
  REPORTED_QUESTION = '/assets/images/REPORTED_QUESTION.svg',
  OPTIONS_BLUE = '/assets/images/OPTIONS_BLUE.svg',

  LEFT_ARROW_SIDE = '/assets/images/LEFT_ARROW_SIDE.svg',
  RIGHT_ARROW_SIDE = '/assets/images/RIGHT_ARROW_SIDE.svg',
  BULK_UPLOAD_USER = '/assets/images/BULK_UPLOAD_USER.svg',
  DRAG_AND_DROP = '/assets/images/DRAG_AND_DROP.svg',
  DOWNLOAD_BULK_UPLOAD_USER = '/assets/images/DOWNLOAD_BULK_UPLOAD_USER.svg',
  BULK_SHORTLISTING_YELLOW = '/assets/images/BULK_SHORTLISTING_YELLOW.svg',
  SCHEDULE_DRIVE_HR_YELLOW = '/assets/images/schedule_drive_hr.svg',
  REMOVE_FAVOURITE = '/assets/images/REMOVE_FAVOURITE.svg',
  MARK_AS_FAVOURITE = '/assets/images/REMOVE_FAVOURITE.svg',
  REMOVE_FROM_FAV_DD = '/assets/images/REMOVE_FROM_FAV_DD.svg',
  MARK_AS_FAV_DD = '/assets/images/MARK_AS_FAV_DD.svg',
  INFO_FAV_POP_UP = '/assets/images/INFO_FAV_POP_UP.svg',
  FAV_DRIVES = '/assets/images/FAV_DRIVES.svg',
  ONGOING_DRIVES = '/assets/images/ONGOING_DRIVES.svg',
  ASSESSMENT_HR = '/assets/images/ASSESSMENT_HR.svg',
  ASSESSMENT_HR_SELECTED = '/assets/images/ASSESSMENT_HR_SELECTED.svg',
  CONSOLIDATED_REPORT_HR = '/assets/images/CONSOLIDATED_REPORT_HR.svg',
  CONSOLIDATED_REPORT_HR_SELECTED = '/assets/images/CONSOLIDATED_REPORT_HR_SELECTED.svg',
  DRIVES_HR = '/assets/images/DRIVES_HR.svg',
  DRIVES_HR_SELECTED = '/assets/images/DRIVES_HR_SELECTED.svg',
  STATS_HR = '/assets/images/STATS_HR.svg',
  STATS_HR_SELECETD = '/assets/images/STATS_HR_SELECTED.svg',
  CANDIDATE_HR = '/assets/images/CANDIDATE_HR.svg',
  CANDIDATE_HR_SELECTED = '/assets/images/CANDIDATE_HR_SELECTED.svg',
  SCHEDULED_DRIVE_HEADING = '/assets/images/SCHEDULED_DRIVE_HEADING.svg',
  COMPLETED_DRIVE = '/assets/images/COMPLETED_DRIVE.svg',
  FAV_DRIVE_HEADING = '/assets/images/FAV_DRIVE_HEADING.svg',

  // Connected-drive break screen (bot interview)
  BOT_INTERVIEW_ILLUSTRATION = '/assets/images/bot-interview-illustration.svg',
  TAKE_BREAK_COFFEE = '/assets/images/take-break-coffee.svg',
  CONTINUE_ARROW_DARK = '/assets/images/continue-arrow-dark.svg',
  // View candidate — Figma redesign
  CANDIDATE_INFO_MAIL = '/assets/images/candidate-info-mail.svg',
  CANDIDATE_INFO_PHONE = '/assets/images/candidate-info-phone.svg',
  CANDIDATE_INFO_ID_CARD = '/assets/images/candidate-info-id-card.svg',
  CANDIDATE_INFO_CLOCK = '/assets/images/candidate-info-clock.svg',
  SCORE_COGNITIVE_BRAIN = '/assets/images/score-cognitive-brain.svg',
  SCORE_TECHNICAL_CODE = '/assets/images/score-technical-code.svg',
  SCORE_SOFT_SKILLS_CHAT = '/assets/images/score-soft-skills-chat.svg',
  SCORE_CODING_LAPTOP = '/assets/images/score-coding-laptop.svg',
  CANDIDATE_SUMMARY_TAB_ICON = '/assets/images/candidate-summary-tab.svg',
  CANDIDATE_SUMMARY_TAB_ICON_INACTIVE = '/assets/images/candidate-summary-tab-inactive.svg',
  PROCTORING_CHECK_TABS = '/assets/images/proctoring-check-tabs.svg',
  PROCTORING_CHECK_MONITOR = '/assets/images/proctoring-check-monitor.svg',
  PROCTORING_CHECK_USB = '/assets/images/proctoring-check-usb.svg',
  STATUS_WARNING_TRIANGLE = '/assets/images/status-warning-triangle.svg',
  STATUS_CHECK_CIRCLE = '/assets/images/status-check-circle.svg',
  FEED_MONITOR = '/assets/images/feed-monitor.svg',
  FEED_PHONE = '/assets/images/feed-phone.svg',
  FEED_SCREEN = '/assets/images/feed-screen.svg',
  FEEDS_START_MERGING = '/assets/images/feeds-start-merging.svg',
  FEEDS_START_PROCTORING = '/assets/images/feeds-start-proctoring.svg',
  VIDEO_PLAY_LARGE = '/assets/images/video-play-large.svg',
  VIDEO_PLAY_SMALL = '/assets/images/video-play-small.svg',
  VIDEO_PAUSE_SMALL = '/assets/images/video-pause-small.svg',
  VIDEO_FULLSCREEN_SMALL = '/assets/images/video-fullscreen-small.svg',

  // Candidate Table Icons
  CANDIDATE_CHIP_PERSON = '/assets/images/candidate-chip-person.svg',
  EYE_VIEW_ICON = '/assets/images/eye-view-icon.svg',
  DOTS_VERTICAL_DARK = '/assets/images/dots-vertical-dark.svg',
  // View Drives of Candidate Popup
  DOC_POPUP_ICON = '/assets/images/doc-popup-icon.svg',
  EYE_DARK_BLUE_60 = '/assets/images/eye-dark-blue-60.svg',
  CALENDAR_POPUP = '/assets/images/calendar-popup.svg',
  TRASH_RED = '/assets/images/trash-red.svg',
  INFO_BLUE = '/assets/images/info-blue.svg',
  GENERATE_CONSOLIDATED_REPORT_HR = '/assets/images/GENERATE_CONSOLIDATED_REPORT_HR.svg',
  // Bulk Shortlisting Modal
  CHECK_SUCCESS = '/assets/images/check-success.svg',
  BULK_FETCH_ICON = '/assets/images/bulk-fetch-icon.svg',
  FILE_BLUE = '/assets/images/file-blue.svg',
  UPLOAD_DARK = '/assets/images/upload-dark.svg',
  FILE_SPREADSHEET_GREEN = '/assets/images/file-spreadsheet-green.svg',
  FILE_REMOVE_X_RED = '/assets/images/file-remove-x-red.svg',
  FILE_SPREADSHEET_BLUE = '/assets/images/file-spreadsheet-blue.svg',
  REGENERATE_REPORT = '/assets/images/regenerate-report.svg',
  REFRESH_REPORTS_TAB = '/assets/images/REFRESH_REPORTS_TAB.svg',
  CALENDAR_BLUE = '/assets/images/calendar-blue.svg',

  // Candidate profile summary card icons
  SUMMARY_PHONE_ICON = '/assets/images/summary-phone-icon.svg',
  SUMMARY_MAIL_ICON = '/assets/images/summary-mail-icon.svg',
  SUMMARY_LOCATION_ICON = '/assets/images/summary-location-icon.svg',

  // Candidate profile field icons
  PROFILE_USER_ICON = '/assets/images/profile-user-icon.svg',
  PROFILE_MAIL_ICON = '/assets/images/profile-mail-icon.svg',
  PROFILE_PHONE_ICON = '/assets/images/profile-phone-icon.svg',
  PROFILE_LOCATION_ICON = '/assets/images/profile-location-icon.svg',
  PROFILE_CLIPBOARD_ICON = '/assets/images/profile-clipboard-icon.svg',
  PROFILE_LINKEDIN_ICON = '/assets/images/profile-linkedin-icon.svg',
  PROFILE_ACCESSIBILITY_ICON = '/assets/images/profile-accessibility-icon.svg',
  PROFILE_WEBSITE_ICON = '/assets/images/profile-website-icon.svg',
  PROFILE_GITHUB_ICON = '/assets/images/profile-github-icon.svg',
  PROFILE_BRIEFCASE_ICON = '/assets/images/profile-briefcase-icon.svg',
  PROFILE_BUILDING_ICON = '/assets/images/profile-building-icon.svg',
  PROFILE_CALENDAR_FIELD_ICON = '/assets/images/profile-calendar-field-icon.svg',
  PROFILE_CLIPBOARD_LIST_ICON = '/assets/images/profile-clipboard-list-icon.svg',
  PROFILE_GRADUATION_ICON = '/assets/images/profile-graduation-icon.svg',
  PROFILE_BOOK_ICON = '/assets/images/profile-book-icon.svg',
  PROFILE_CHART_ICON = '/assets/images/profile-chart-icon.svg',
  PROFILE_AWARD_ICON = '/assets/images/profile-award-icon.svg',
  PROFILE_CLOCK_ICON = '/assets/images/profile-clock-icon.svg',
  PROFILE_BANKNOTE_ICON = '/assets/images/profile-banknote-icon.svg',
  EXPECTED_CTC = '/assets/images/EXPECTED_CTC.svg',
  OFFER_IN_HAND_CTC = '/assets/images/OFFER_IN_HAND_CTC.svg',

  // Import Shortlisted Modal
  UPLOAD_CLOUD_DARK = '/assets/images/upload-cloud-dark.svg',

  // CANDIDATE DETAILS ICONS
  DRIVE_SETTING_ADD_ANOTHER_MAIL = '/assets/images/DRIVE_SETTING_ADD_ANOTHER_MAIL.svg',
  DRIVE_SETTINGS = '/assets/images/DRIVE_SETTINGS.svg',
  SEND_MAIL = '/assets/images/SEND_MAIL.svg',
  DRIVE_SHARE = '/assets/images/DRIVE_SHARE.svg',
  DRIVE_LINK_CHAIN_BLUE = '/assets/images/drive-link-chain-blue.svg',
  DRIVE_LINK_CHAIN_GRAY = '/assets/images/DRIVE_LINK_CHAIN_GRAY.svg',
  DRIVE_MOBILE_GRAY = '/assets/images/drive-mobile-gray.svg',
  DRIVE_MOBILE_BLUE = '/assets/images/DRIVE_MOBILE_BLUE.svg',
  DRIVE_LINK_COPY_AMBER = '/assets/images/drive-link-copy-amber.svg',

  // Export Excel Modal
  EXPORT_EXCEL_HEADER = '/assets/images/export-excel-header.svg',
  EXPORT_TAB_ALL_CANDIDATES = '/assets/images/export-tab-all-candidates.svg',
  EXPORT_TAB_SHORTLISTED = '/assets/images/export-tab-shortlisted.svg',

  // Consolidated Report Modal
  CONSOLIDATED_REPORT_MODAL = '/assets/images/consolidated-report-modal.svg',

  SELECT_DRIVE_TYPE_HR = '/assets/images/SELECT_DRIVE_TYPE_HR.svg',
  DRIVE_DETAILS_REPORT = '/assets/images/DRIVE_DETAILS_REPORT.svg',
  GENERATE_REPORT_DRIVE_DETAILS = '/assets/images/GENERATE_REPORT_DRIVE_DETAILS.svg',

  // Workday Failures
  WORKDAY_ALERT_TRIANGLE = '/assets/images/workday-alert-triangle.svg',

  // Back to Top button
  BACK_TO_TOP_ICON = '/assets/images/back-to-top-icon.svg',
  UNBLOCK_CANDIDATE = '/assets/images/UNBLOCK_CANDIDATE.svg',
  DOWNLOAD_MERGED_URL = '/assets/images/DOWNLOAD_MERGED_URL.svg',

  // Staffing images
  RESET_FILTERS = '/assets/images/reset_filters.svg',
  CHOOSE_FILES = '/assets/images/choose-file-staffing.svg',
  FILE_IMAGE_STAFFING = '/assets/images/file-image-staffing.svg',
  FILE_IMAGE_STAFFING_NEW_UX = '/assets/images/file-image-staffing-new-ux.svg',
  FILE_READY_TO_UPLOAD_NEW_UX = '/assets/images/ready-to-upload.svg',
  DELETE_IMAGE_SATFFING = '/assets/images/delete-icon-54.svg',
  ACCORDIAN_ICON = '/assets/images/accordian.svg',
  MULTI_SORT_ICON = '/assets/images/multi-arrow-sorting.svg',
  SINGLE_SORT_ICON = '/assets/images/single-arrow-sorting.svg',
  DROPDOWN_ARROW_2 = '/assets/images/dropdown-arrow2.svg',
  BRAND_COLOR_INFO_ICON = '/assets/images/brand-color-info-icon.svg',
  NO_RECORDS = '/assets/images/no-records.svg',
  ACTIVE_FILTER_ICON = '/assets/images/active-filter.svg',
  DROPDOWN_ICONS67 = '/assets/images/dropdown_icons67.svg',
  CORRECT_CHECKLIST = '/assets/images/correct_checklist.svg',
  STAFFING_SOUND_ICON = '/assets/images/sound-staffing-icon.svg',
  BLUE_CROWN = '/assets/images/blue-crown.svg',
  WHITE_DOWNLOAD_ICON1 = '/assets/images/white_Download_icon1.svg',
  USER_PROCTORING_ICON = '/assets/images/proctoring_video.png',
  WHITE_WATCH = '/assets/images/watch-white.svg',
  HOVER_SELECT = '/assets/images/hover-select.svg',
  RECOMMENDED_WHITE_ICON = '/assets/images/recommend-white.svg',
  BLUE_INFO_CIRCLE_ICON = '/assets/images/blue-info-circle.svg',
  UPTREND_ICON = '/assets/images/uptrend.svg',
  DOWNTREND_ICON = '/assets/images/downtrend.svg',
  TILTED_WHITE_ARROW = '/assets/images/tilted-white-arrow.svg',
  MANUALLY_MAPPED_ICON = '/assets/images/manually-mapped-icon.svg',
  WHITE_DELETE_ICON = '/assets/images/whiteDelete.svg',
  WHITE_EDIT_ICON1 = '/assets/images/whiteEdit.svg',
  DRAG_AND_DROP_ICON = '/assets/images/drag_drop_icon.svg',
  PERSON_IMAGE_24 = '/assets/images/person-image24.svg',
  END_CALL_ICON = '/assets/images/endCallIcon.svg',
  CLOSE_SEARCH_GREY = '/assets/images/close-circle_grey.svg',
  DELETE_BLUE_COLOR = '/assets/images/delete_blue_color.svg',
  FUNCTION_ICON_GRAY = '/assets/images/function-icon-gray.svg',
  CLOCK_ICON_GRAY = '/assets/images/clock-icon-gray.svg',
  LOCATION_ICON_GRAY = '/assets/images/location-icon-gray.svg',
  VIEW_ICON_BLUE = '/assets/images/view-icon-blue.svg',
  EDUCATION_ICON = '/assets/images/education-icon.svg',
  VIEW_REPORT_BTN = '/assets/images/view-report-btn.svg',
  RIGHT_ARROW_ICON = '/assets/images/right-arrow-icon.svg',
  MICROSOFT_ICON = '/assets/images/microsoft-icon.svg',
  MICROSOFT_ICON_WHITE_COLOR = '/assets/images/microsoft-icon-white.svg',
  EXPORT_DOWNLOAD_ICON = '/assets/images/export-document-download.svg',
  SUITCASE = '/assets/images/suitcase.svg',
  DARK_RED_CROSS = '/assets/images/dark-red-cross.svg',
  STAFFING_GITHUB_ICON = '/assets/images/github-icon1.svg',
  STAFFING_LINKEDIN_ICON = '/assets/images/linkedin-staffing-icon1.svg',
  PROFILE_COVER_IMAGE_STAFFING = '/assets/images/profile-cover.svg',
  BLUE_DELETE_ICON = '/assets/images/blue-delete-icon.svg',
  FRACTAL_LOGO1 = '/assets/images/staffing-iqigai-logo.svg',
  STAFFING_AND_PM_CAORUSAL1 = '/assets/images/Staffing-carousal1.png',
  STAFFING_AND_PM_CAORUSAL2 = '/assets/images/Staffing-carousal2.png',
  STAFFING_CANDIDATE_CAORUSAL1 = '/assets/images/Staffing-Candidate-carousal1.png',
  STAFFING_CANDIDATE_CAORUSAL2 = '/assets/images/Staffing-Candidate-carousal2.png',
  STAFFING_CANDIDATE_CAORUSAL3 = '/assets/images/Staffing-Candidate-carousal3.png',
  FULL_FRACTAL_LOGO = '/assets/images/fractal-logo.png',

  STAFFING_CAROUSEL_2_AVATAR_1 = '/assets/images/staffing-carousel-2-avatar-1.svg',
  STAFFING_CAROUSEL_2_AVATAR_2 = '/assets/images/staffing-carousel-2-avatar-2.svg',
  STAFFING_CAROUSEL_2_AVATAR_3 = '/assets/images/staffing-carousel-2-avatar-3.svg',
  STAFFING_CAROUSEL_2_BG = '/assets/images/staffing-carousel-2-bg.png',

  STAFFING_CAROUSEL_1_BG = '/assets/images/staffing-carousel-1-bg.png',
  STAFFING_CAROUSEL_2_BOX_1 = '/assets/images/staffing-carousel-2-box-B.png',
  STAFFING_CAROUSEL_2_BOX_2 = '/assets/images/staffing-carousel-2-box-A.png',
  STAFFING_CAROUSEL_2_BOX_3 = '/assets/images/staffing-carousel-2-box-C.png',
  STAFFING_CAROUSEL_2_METRICS_1 = '/assets/images/staffing-carousel-2-metrics-1.png',
  STAFFING_CAROUSEL_2_CHART_1 = '/assets/images/staffing-carousel-2-chart-1.png',
  STAFFING_INFO_ICON = '/assets/images/info_staffing-icon.svg',
  CANDIDATE_CAROUSEL_1_BG_VIDEO = '/assets/gifs/candidate-carousel-1-bg.mp4',
  CANDIDATE_CAROUSEL_1_AVATAR = '/assets/images/candidate-carousel-1-avatar.png',
  CANDIDATE_CAROUSEL_2_AVATAR = '/assets/images/candidate-carousel-2-avatar.png',
  CANDIDATE_CAROUSEL_2_BG_GIF = '/assets/gifs/candidate-carousel-2-bg.gif',
  CANDIDATE_CAROUSEL_3_AVATAR = '/assets/images/candidate-carousel-3-avatar.png',
  CANDIDATE_CAROUSEL_3_BG_VIDEO = '/assets/gifs/candidate-carousel-3-bg.mp4',
  CHATGPT_IMAGE1 = '/assets/images/chat-gpt-image1.svg',
  STAFFING_CLOCK = '/assets/images/staffingclock.svg',
  EXIT_FULL_SCREEN = '/assets/images/exitfull-screen.svg',
  RELOAD_PAGE = '/assets/images/reload-page.svg',
  THREE_DOTS_STAFFING = '/assets/images/threeDotsStaffing.svg',
  DELETE_ICON43 = '/assets/images/delete-icon43.svg',
  DELETE_BOLD = '/assets/images/delete_bold.svg',
  PERSON_ICON_MANUAL_MATCHED = '/assets/images/person_icon-manual_matched.svg',
  CROSS_ICON_FOR_FILTERS = '/assets/images/cross-icon-for-filters.svg',
  DEFAULT_SORT='/assets/images/default_sort.svg',
  HOVER_DEFAULT_SORT='/assets/images/hover_default_sort.svg',
  ASC_SORT='/assets/images/asc_sort_new_ux.svg',
  DESC_SORT='/assets/images/desc_sort_new_ux.svg', 
  BACK_ICON_NEW_UX_STAFFING ='/assets/images/back_icon_new_ux.svg',
  BACK_ICON__BLUE_VERSION_NEW_UX_STAFFING ='/assets/images/back_icon_blue_version_new_ux.svg',
  INACTIVE_CHEVRON='/assets/images/inactive-chevron.svg',
  ACTIVE_CHEVRON='/assets/images/active-chevron.svg',
  PLUS_ICON_NEW_UX='/assets/images/PlusIcon_new_ux.svg',
  PLUS_ICON_NEW_UX_HOVER='/assets/images/PlusIcon_new_ux_hover.svg',
  DROPDOWN_ICON_NEW_UX='/assets/images/dropdown-arrow-new-ux.svg',
  DROPDOWN_ICON_NEW_UX_HOVER='/assets/images/dropdown-arrow-new-ux-hover.svg',
  DROPDOWN_ICON_NEW_UX_HOVER_DARK_BLUE_THEME='/assets/images/dropdown-arrow-new-ux-hover_dark_blue.svg',
  DROPDOWN_ICON_NEW_UX_HOVER_PRIMARY_BLUE_THEME='/assets/images/dropdown-arrow-new-ux-hover_primary_blue.svg',
  DEFAULT_SORT_NEW_UX_ICON ='/assets/images/default-sort-new-ux.svg',
  HOVER_SORT_NEW_UX_ICON ='/assets/images/hover-sort-new-ux.svg',
  UPLOAD_DATA_NEW_UX_ICON='/assets/images/upload-data-new-icon.svg',
  BACK_TO_TOP_ICON_NEW_UX ='/assets/images/back-to-top-icon_new_ux.svg',
  NEW_ICON_FOR_DATE='/assets/images/new_ux_for_date.svg',
  DELETE_ICON_FOR_CUSTOM_FILTER='/assets/images/custom_filter_delete.svg',
  SUCCESS_FILE_ICON='/assets/images/success-file-tick.svg',
  INPROGRESS_FILE_ICON='/assets/images/inprogress-file-tick.svg',
  FAILED_FILE_ICON='/assets/images/failed-file-tick.svg',
  DATE_TIME_PICKER='/assets/images/date-time-picker.svg',
  TOAST_TICK_ICON='/assets/images/toast-tick-icon.svg',
  TOAST_ERROR_ICON='/assets/images/toast-error-icon.svg',
  TOAST_INFO_ICON='/assets/images/toast-info-icon.svg',

  DOWNLOAD_ICONS_BLUE='/assets/images/downlaod_icon-blue.svg',
  COLUMNS_ICONS_BLUE='/assets/images/columns-icon-blue.svg',
  CLOCK_ICONS_BLUE='/assets/images/clock-icon-blue.svg',
  EDIT_ICONS_WITH_BAR='/assets/images/edit_icon_with-bar.svg',
  ARROW_SQUARE_DROPDOWN = '/assets/images/arrow-square-down.svg',
  ARROW_SQUARE_DROPDOWN_ON_HOVER = '/assets/images/arrow-square-down-hover.svg',
  ARROW_SQUARE_DROPDOWN_ON_DROPDOWN_OPEN = '/assets/images/arrow-square-down_dropdownopen.svg',
  SQUARE_PEN_ICON= '/assets/images/square-pen.svg',
  DOWNLOAD_ICONS_BRIGHT_BLUE='/assets/images/download_blue_theme.svg',
  LATEST_HISTORY_ICON='/assets/images/latest-history.svg',
  BULK_UPDATE_ICON='/assets/images/bulk-update.svg',
  EDIT_ICON_FOR_HISTORY='/assets/images/edit-icon-history.svg',

  TRACKER_DEFAULT = '/assets/images/tracker-default.svg',
  TRACKER_HOVER_STATE = '/assets/images/tracker-hover-state.svg',
  TRACKER_ACTIVE = '/assets/images/tracker-active.svg',
  SPREADSHEET_ICON='/assets/images/file-spreadsheet.svg',
  DOWNLAOD_ICON_FOR_UPLAOD_HISTORY='/assets/images/download-for-history.svg',
  RESTORE_HOVER_ICON='/assets/images/restore-hover-icon.svg',
  RESTORE_ICON ='/assets/images/restore-icon.svg',
  EDIT_HOVER_ICON3='/assets/images/edit_hover_icon2.svg',

  CLOCK_HOVER_ICON='/assets/images/clock-hover.svg',
  COLUMN_HOVER_ICON='/assets/images/column-hover.svg',
  DOWNLOAD_HOVER_ICON='/assets/images/download-hover.svg',

  // Sidebar hover state icons
  HOME_HOVER_STATE = '/assets/images/home-hover-state-sidebar.svg',
  DRIVES_HOVER_STATE = '/assets/images/drives-hover-state-sidebar.svg',
  PROFILE_HOVER_STATE = '/assets/images/profile-hover-state-sidebar.svg',
  DOCUMENT_UPLOAD_HOVER_STATE = '/assets/images/document-upload-hover-state-sidebar.svg',
  // SR Tab
  SR_HR='/assets/images/SR_HR.svg',
  SR_HR_SELECTED='/assets/images/SR_HR_SELECTED.svg',
  // blue (lite theme) variants of the HR sidebar selected icons
  SR_HR_SELECTED_BLUE='/assets/images/SR_HR_SELECTED_BLUE.svg',
  DRIVES_HR_SELECTED_BLUE='/assets/images/DRIVES_HR_SELECTED_BLUE.svg',
  CANDIDATE_HR_SELECTED_BLUE='/assets/images/CANDIDATE_HR_SELECTED_BLUE.svg',
  CONSOLIDATED_REPORT_HR_SELECTED_BLUE='/assets/images/CONSOLIDATED_REPORT_HR_SELECTED_BLUE.svg',
  ASSESSMENT_HR_SELECTED_BLUE='/assets/images/ASSESSMENT_HR_SELECTED_BLUE.svg',
  STATS_HR_SELECTED_BLUE='/assets/images/STATS_HR_SELECTED_BLUE.svg',
  ADD_SR_YELLOW='/assets/images/ADD_SR_YELLOW.svg',
  SR_FILE_UPLOAD_ICON='/assets/images/sr-file-upload-icon.svg',
  ADD_SR_POP_UP='/assets/images/ADD_SR_POP_UP.svg',
  CONFIGURE_WORKFLOW_ICON='/assets/images/configure-workflow-icon.svg',
  PLUS_DRIVE_BLUE='/assets/images/plus-drive-blue.svg',
  ADD_STAGE_POP_UP='/assets/images/ADD_STAGE_POP_UP.svg',

  SR_CANDIDATE_MAIL_ICON='/assets/images/sr-candidate-mail.svg',
  SR_CANDIDATE_PHONE_ICON='/assets/images/sr-candidate-phone.svg',
  SR_CANDIDATE_RESUME_ICON='/assets/images/sr-candidate-resume.svg',
  ADD_STAGE_SR='/assets/images/ADD_STAGE_SR.svg',
  SYSTEM_GENERATED_STAGES_ICON='/assets/images/SYSTEM_GENERATED_STAGES_ICON.svg',

  // Configure Workflow Enhanced
  WORKFLOW_WEIGHT_WARNING = '/assets/images/workflow-weight-warning.svg',
  ADD_DRIVE_PLUS_ICON='/assets/images/ADD_DRIVE_PLUS_ICON.svg',
  PRECENTAGE='/assets/images/PRECENTAGE.svg',
  CONFIRM_WORKFLOW='/assets/images/COONFIRM_WORKFLOW.svg',
  BOT_STAGE_SR='/assets/images/BOT_STAGE_SR.svg',
  TOTAL_WEIGHTAGE_EQUAL='/assets/images/TOTAL_WEIGHTAGE_EQUAL.svg',
  // Workday Stage Table
  DOCUMENT_TEXT_BLUE = '/assets/images/document-text-blue.svg',
  INFO_DARK_MUNSELL = '/assets/images/info-dark-munsell.svg',
  REMAINING_TIME_SR='/assets/images/REMAINING_TIME_SR.svg',
  EXPIRE_SR='/assets/images/EXPIRE_SR.svg',

  MIDDLE_SECTION = '/assets/images/middle-section.png',
  KPI_SUMMARY_GRID = '/assets/images/KPI-Summary-Grid.png',
  METRICS_ROW = '/assets/images/metrics-row.png',
  OPENINGS_BY_COUNTRY = '/assets/images/Openings by Country.png',
  TEAM_PERFORMANCE_CARD = '/assets/images/team-performance-card.png',

  CAMERA_VIOLATION_1 = '/assets/images/camera-violation_1.svg',
  CAMERA_VIOLATION_2 = '/assets/images/camera-violation_2.svg',
  CAMERA_VIOLATION_3 = '/assets/images/camera-violation_3.svg',
  START_BUDDY_AVATAR = '/assets/images/start-buddy-avatar.svg',
  ACTIVE_TASK = '/assets/images/active-task.svg',
  ACTIVE_TIMER = '/assets/images/active-timer.svg',
  ACTIVE_CALL_SLASH = '/assets/images/active-call-slash.svg',
  BLOCK_CANDIDATE = '/assets/images/block-candidate.svg',
  RECOMMENDED_CANDIDATE = '/assets/images/recommended-candidate.svg',
  SELECTED_CANDIDATE = '/assets/images/selected-candidate.svg',
}
